import { Id, PaginatedAutoDataList, isSuccess, laravelPaginatedListFetchConfig } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { useEventListColumns } from "../events/eventList/useEventListColumns";
import { userEventService } from "../shared/api/event/eventService";

export const UserEventList: FC = () => {
	const { t } = useTranslation();
	const { userId = "" } = useParams();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const service = useMemo(() => userEventService(userId), [userId]);
	const detachEvents = useCallback(
		async (eventId: Id) => {
			const response = await service.detachEvents(eventId);

			if (isSuccess(response)) {
				void queryClient.invalidateQueries({ queryKey: service.listKey });
			}
		},
		[queryClient, service],
	);
	const { eventListColumns } = useEventListColumns({ onDetachEvent: detachEvents, showPreviewButton: true });

	return (
		<PaginatedAutoDataList
			name="userEvents"
			heading={t("User events")}
			empty={t("This user does not have any event assigned.")}
			columns={eventListColumns}
			listFetchConfig={laravelPaginatedListFetchConfig(service.listKey, service.index)}
			onRowClick={({ id }) => navigate(`/events/active/${id}/details`)}
		/>
	);
};
